import { formatPhone, SectionHeader } from '@flos/react-ui';
import { format } from 'date-fns';
import { da } from 'date-fns/locale';
import { useEffect } from 'react';
import { useResourceBundle } from '../contexts/ResourceContext';
import { useAppSelector } from '../hooks/useRedux';
import { isScheduledBooking } from '../services/callback-whitelist';
import { isLocalTimeZoneSameAsCopenhagenTimeZone } from '../services/timezone';
import { trackConversion } from '../services/tracking';
import { NavigationState } from '../store/navigation.type';
import { callStartTime, DATE_FORMAT_DISPLAY } from '../utils/date-utils';

const determineBookingOptionMessage = (navigation: NavigationState, resource: ReturnType<typeof useResourceBundle>) => {
  const mobile = formatPhone(navigation.mobile);

  if (isScheduledBooking(navigation)) {
    const dateTimeString = format(
      callStartTime(navigation.bookingDate!, navigation.bookingTime!),
      DATE_FORMAT_DISPLAY,
      { locale: da }
    );

    return (
      <>
        <div className="u-spacing-stack-m">
          {resource['label.receipt.content.scheduled']
            .replace(/\{0\}/g, dateTimeString)
            .replace(/\{1\}/g, String(mobile))}
        </div>
        <div className="u-spacing-stack-xl">
          {!isLocalTimeZoneSameAsCopenhagenTimeZone() && resource['label.schedule.timezone.different']}
        </div>
      </>
    );
  } else {
    return <div className="u-spacing-stack-xl">{`${resource['label.receipt.content.soonest']} ${mobile}.`}</div>;
  }
};

const Receipt = () => {
  const resource = useResourceBundle();
  const navigation = useAppSelector((state) => state.navigation);
  const message = determineBookingOptionMessage(navigation, resource);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Tracking
    trackConversion(navigation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SectionHeader title={resource['label.receipt.header']} />
      {message}
      <div dangerouslySetInnerHTML={{ __html: resource['label.disclaimer'] }}></div>
    </>
  );
};

export default Receipt;
